let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bfmmF")).then(() => parcelRequire('a7H0a'));